import script from "./applyGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./applyGrid.vue?vue&type=script&setup=true&lang=js"

import "./applyGrid.vue?vue&type=style&index=0&id=5ff0ab2a&lang=css"

const __exports__ = script;

export default __exports__